import React, { useEffect, useState } from 'react';
import { CheckCircle2, AlertCircle, Info as InfoIcon } from 'lucide-react';
import './toast.scss';

type ToastType = 'info' | 'error' | 'success';
interface T { id: number; message: string; type: ToastType; }

let listeners: ((t: T) => void)[] = [];
let counter = 0;

/** Muestra un toast (reemplaza a window.alert). */
export function showToast(message: string, type: ToastType = 'info') {
  listeners.forEach(l => l({ id: ++counter, message, type }));
}

/** Contenedor de toasts — se monta una sola vez en la app. */
export const ToastHost: React.FC = () => {
  const [toasts, setToasts] = useState<T[]>([]);
  useEffect(() => {
    const l = (t: T) => {
      setToasts(prev => [...prev, t]);
      setTimeout(() => setToasts(prev => prev.filter(x => x.id !== t.id)), 4500);
    };
    listeners.push(l);
    return () => { listeners = listeners.filter(x => x !== l); };
  }, []);

  const icon = (t: ToastType) =>
    t === 'error' ? <AlertCircle size={18} /> : t === 'success' ? <CheckCircle2 size={18} /> : <InfoIcon size={18} />;

  return (
    <div className="toast-host">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast--${t.type}`} onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}>
          {icon(t.type)} <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
};

export default ToastHost;
